/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <div class="caption">
      <div>*NC: {{ $t('Not Connected') }}</div>
    </div>
    <Card>
      <Toolbar>
        <v-flex sm2>
          <v-toolbar-title class="body-2">{{ $t('Inverter') }} {{ $t('Channel') }}</v-toolbar-title>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex text-sm-center>
          <v-btn-toggle v-model="buttonvalue" mandatory v-if="view === 'overview'" :class="theme === 'dark' ? 'activeButton' : 'grey lighten-1'" >
            <v-btn flat color="white" value="live">{{ $t('Live') }}</v-btn>
            <v-btn flat color="white" value="avg">{{ $t('Average') }}</v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex sm2/>
      </Toolbar>
        <v-layout row wrap>
          <v-flex sm9 v-show="view === 'overview'">
            <v-data-table class="elevation-1 zone-moni" :headers="headers" :items="responseData" :pagination.sync="pagination" hide-actions select-all>
              <template v-slot:headers="props">
                <tr>
                  <th :input-value="props.all" :indeterminate="props.indeterminate" :disabled="type === 'scb'" primary
                    hide-details>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    @click="changeSort(header.value)"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                  >
                    {{ header.text }}
                    <v-icon small v-show="header.text != ''">arrow_upward</v-icon>
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr class="primary" :active="inverterState[props.item['Equipment [Block / Room / Device Name]']]">
                  <td>
                    <v-checkbox v-model="inverterState[props.item['Equipment [Block / Room / Device Name]']]"
                      @click.native="inverterSelected( ncdata,props.item.id,props.item['Equipment [Block / Room / Device Name]'],inverterState[props.item['Equipment [Block / Room / Device Name]']],props.index);"
                      :input-value="inverterState[props.item['Equipment [Block / Room / Device Name]']]"
                      :disabled="type === 'scb'" primary hide-details></v-checkbox>
                  </td>
                  <template v-for="(items,key,index) in props.item">
                    <td class="text-xs-center" :key="index" v-if="key != 'id'">
                      {{ ncdata[props.item.id] && ncdata[props.item.id].indexOf(`${index -1}`) !== -1 ? 'NC' : index > 1 ? (items != null ? parseInt(items).toFixed(2) : 'N/A') : items }}
                    </td>
                  </template>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex sm9 v-show="view === 'graph'">
            <div>
              <GlobalGraph class="globalgraph" v-if="series.length" :series="series" :xAxisData="xAxis" :yAxis="yAxis" :theme="theme" />
            </div>
          </v-flex>
          <v-flex sm3 pl-2 ma-0>
          <v-layout row wrap>
              <Card class="combobox-card">
                <div v-show="chips.length == 0" class="combobox-img">
                  <div class="mt-4">{{ $t('Please select the channels in order to check graph') }}</div>
                  <div class="mt-4">
                    <img src="../assets/selectOption.svg" alt="choose" height="80px" width="80px">
                  </div>
                </div>
                <div v-show="chips.length > 0">
                  <v-chip v-for="(chip, index) in chips" :key="index"  :selected="true"
                  :color="colors[index]" @click.native="chip(index)" @input="remove(chip.modifiedId, chip.name)" small close>
                    <strong>{{ chip.name }}</strong>
                  </v-chip>
                </div>
              </Card>
            <v-flex xs12>
              <v-btn class="full-width ma-0" color="info" v-on:click="graph" v-show="isShowGraphButtonEnabled">
                {{ $t('Show Graph') }}
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-btn class="full-width ma-0" color="info" v-on:click="showOverview" v-if="view === 'graph'">
                {{ $t('Show Table') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </Card>
  </div>
</template>

<script>
import service from '@/services/zone-monitoring.js'
import {
  mapGetters,
  mapMutations
} from 'vuex'
import { mapGettersMixin, colorMixin } from '@/util/mixin/index.js'
const DataTable = () => import('@/components/scb/customTable')
const moment = require('moment')
const momentTz = require('moment-timezone')

export default {
  name: 'name',
  components: {
    DataTable
  },
  mixins: [mapGettersMixin, colorMixin],
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      headers: [],
      responseData: [],
      chips: [],
      channels: [],
      selected: [],
      ncdata: [],
      series: [],
      xAxis: [],
      yAxis: [{
        name: 'Current (A)',
        axisLabel: {
          formatter: '{value}',
          rotate: 40
        }
      }],
      isShowGraphButtonEnabled: true,
      view: 'overview',
      buttonvalue: 'live',
      type: 'inverter',
      inverterState: {},
      tempSearchList1: {},
      pagination: {
        sortBy: "Equipment [Block / Room / Device Name]",
        descending: false,
        page: 1,
        rowsPerPage: 500,
      },
      filter:[
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
      activeFilter: {},
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantTimezone']),
    date() {
      return this.activeFilter.Date ? this.activeFilter.Date.from : '';
    },
    isLive() {
      return this.date
        ? momentTz().tz(this.getActivePlantTimezone).isSame(this.date, 'day')
        : true
    }
  },
  mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if (child.type === 'singleDatePicker') {
        const parameters = ['from', 'to']
        parameters.forEach(key => {
          if (!Obj[child.id]) { Obj[child.id] = {} }
          Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
        })
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)

    this.setIntervalWithoutDelay(this.callAllApi)
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_SHOW_SNACKBAR',
      'SET_SNACKBAR_CONTENT',
      'SET_PROGRESS_BAR'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      if (this.view === 'graph') {
        this.getStringData()
      } else {
        this.getTableData()
      }
    },
    changeSort(column) {
      if (column != "") {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
    inverterSelected(ncid, id, equipment, state, index) {
      this.channels = []
      let range = Object.keys(this.responseData[index]).length - 2
      if (state) {
        // When checkbox is checked
        for (var i = 0; i < range; i++) {
          this.channels.push(i + 1)
        }
        if (ncid[id] !== undefined) {
          Object.entries(ncid[id]).forEach(([key, value]) => {
            if (this.channels.includes(value) == false) {
              let key = this.channels.indexOf(parseInt(value))
              this.channels.splice(key, 1)
            }
          })
        }
        Object.entries(this.channels).forEach(([key, value]) => {
          this.chips.push({
            id,
            modifiedId: id.concat('-ch-', value),
            name: equipment.concat('-ch-', value)
          })
        })
        this.tempSearchList1[id] = this.channels
      } else {
        // When checkbox is unchecked
        for (let i = 1; i <= range; i++) {
          this.chips = this.chips.filter((item) => item.id !== id)
        }
        delete this.tempSearchList1[id]
      }
      this.dataLength = this.chips.length
    },
    remove(item, name) {
      let it = item.replace(' ', '-')
      let r = it.replace(' ', '-')
      let splitKey = r.split('-')
      let key = splitKey[0] + '-' + splitKey[1] + '-' + splitKey[2]
      let value = splitKey[4]
      this.chips = this.chips.filter((item) => item.name !== name)
      let ch = this.tempSearchList1[key].indexOf(parseInt(splitKey[4]))
      this.tempSearchList1[key].splice(ch, 1)
      this.tempSearchList1[key] = [...this.tempSearchList1[key]]
      if (!this.isShowGraphButtonEnabled) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    },
    getParam(type) {
      switch (type) {
        case 'overview':
          return {
            plantId: this.getSelectedPlantId,
            index: this.buttonvalue,
            date: this.date
          }
        case 'graph':
          var temp = {}
          temp = this.tempSearchList1
          return {
            plantId: this.getSelectedPlantId,
            dateTo: this.date,
            dateFrom: this.date,
            type: this.type,
            idList: temp
          }
      }
    },
    graph() {
      if (this.chips.length > 0) {
        this.view = 'graph'
        this.setIntervalWithoutDelay(this.callAllApi)
        this.isShowGraphButtonEnabled = false
      } else {
        let payload = {
          icon: 'error',
          message: 'Please select some option'
        }
        this.SET_SNACKBAR_CONTENT(payload)
        this.SET_SHOW_SNACKBAR(true)
      }
    },
    showOverview() {
      this.isShowGraphButtonEnabled = true
      this.view = 'overview'
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    async getTableData() {
      this.responseData = []
      this.headers = []
      let response = await service.getStingInverterData(
        this.getParam('overview')
      )
      let count = await service.getStringCount(this.getSelectedPlantId)
      if (response.status === 200) {
        this.responseData = response.data.message.data
        this.ncdata = count.data.message
        this.headers = response.data.message.headers
      }
    },
    async getStringData() {
      try {
        this.SET_PROGRESS_BAR(true)
        let param = this.getParam('graph')
        let response = await service.getStringDataGraph(param)
        this.SET_PROGRESS_BAR(false)
        this.series = []
        Object.keys(response.data.message.response).forEach(current => {
          this.series.push({
            name: current,
            type: 'line',
            data: response.data.message.response[current]
          })
        })
        this.xAxis = response.data.message.axis
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    chips: function () {
      if (this.chips.length === 0) {
        this.type = ''
        this.tempSearchList1.length = 0
        this.tempSearchList1 = {}
        this.selected = []
        this.view = 'overview'
        this.isShowGraphButtonEnabled = true
        const self = this
        Object.keys(this.inverterState).forEach(id => {
          self.inverterState[id] = false
        })
      }
    },
    getSelectedPlantId() {
      this.showOverview()
      this.chips = []
    },
    buttonvalue(change) {
      this.buttonvalue = change
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    },
    date(newVal, oldVal) {
      if (oldVal != '') {
        this.callAllApi()
      }
    }
  }
}
</script>

<style scoped>

  .combobox-card {
  width: 99%;
  height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}

.combobox-img {
  text-align: center;
}

  .full-width {
    width: 100%;
  }

  .caption {
    /* background-color: transparent !important; */
    text-align: right;
    padding: 3px 24px;
    font-style: italic;
    letter-spacing: 0.03125rem;
  }
  .zone-moni {
    height: 500px;
    max-height: 500px;
    overflow: auto;
    display: flex;
  }

  .zone-moni .v-table__overflow {
    overflow: auto;
  }

  .globalgraph {
  width: 100%;
  height: 400px;
  }
</style>
